import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  errorSaveFormTitle: {
    id: 'proforma-form-system.controllers.form-index.save-form-invalid-answers-flag-title',
    defaultMessage: 'We couldn’t save your changes',
    description: 'The title on the error flag informing customers that their form failed to save.'
  },
  errorSaveFormInvalidAnswersDescription: {
    id: 'proforma-form-system.controllers.form-index.save-form-invalid-answers-flag-description',
    defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
    description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
  },
  errorSaveFormFailedOnConflictDescription: {
    id: 'proforma-form-system.controllers.form-index.save-form-failed-on-conflict-flag-description',
    defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
    description: 'The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state does not allow the customer to do so.'
  },
  errorSaveFormServerErrorDescription: {
    id: 'proforma-form-system.controllers.form-index.save-form-failed-server-error-flag-description',
    defaultMessage: 'A server error occurred while trying to save the form.'
  }
});